import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 6h6V5H5v1zm0-2h6V3H5v1zm0 4h4V7H5v1zm3.013 2.866v2.12h2.121l1.865-1.866.622-.62 2.872-2.872-2.121-2.122-5.36 5.36zm4.652-3.238l.707-.708.707.708-.707.706-.707-.706zM9.013 11.28l2.944-2.946.708.708-2.945 2.945h-.707v-.707z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 13c0 .551-.449 1-1 1H5c-.551 0-1-.449-1-1V3c0-.551.449-1 1-1h6c.551 0 1 .449 1 1v2.465l1-1V3c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-1.465l-1 1V13z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 18h18v-3H15v3zm0-6h18V9H15v3zm0 12h12v-3H15v3zm9.04 8.597v6.362h6.363L36 33.361l1.866-1.862h-.002l8.616-8.616-6.362-6.364L24.04 32.597zm13.955-9.714l2.122-2.122 2.122 2.122-2.122 2.12-2.122-2.12zM27.04 33.84l8.834-8.836 2.124 2.122-8.836 8.836H27.04V33.84z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 39c0 1.654-1.346 3-3 3H15c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v7.394l3-3V9c0-3.308-2.692-6-6-6H15c-3.308 0-6 2.692-6 6v30c0 3.308 2.692 6 6 6h18c3.308 0 6-2.692 6-6v-4.394l-3 3V39z",
    clipRule: "evenodd"
  }))
};
export var Notes = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});